export const getInitialPrintMenu = (initialPrintMenuResponse, params, menuClickEvent, callFrom) => {

    var translate = window.translate;

    var updatedPrintMenu = {
        PrintData: [],
    }

    if (initialPrintMenuResponse.length > 0 || initialPrintMenuResponse != null || typeof initialPrintMenuResponse != undefined) {

        initialPrintMenuResponse.forEach((item, i) => {
            var fnName = params.fnNames[i];
            var tempObj = {};

            if (item.RdlName === "MasterBOL" && callFrom == "manageOrder") {
                return; // skipping MasterBOL menu for manageOrder
            }

            tempObj = {
                "name": item.CategoryName,
                "value": [],
                "disabled": (params.SelectedOrders < 1) || !params.Rights.hasOwnProperty('orders.docs'),
                "disabledText": translate("order_Document_Permission_note"),
                'isContextMenu': true,
                'isButtonMenu': true,
                "wmsSelector": params.Selector + item.RdlName,
                "onClickFunc": menuClickEvent,
                'wmsid': item.RdlName
            };

            if (callFrom == "findOrder") {
                if(item.CategoryName == "Shipping labels"){
                    tempObj.disabled =  (params.SelectedOrders < 1) || !params.Rights.hasOwnProperty('orders.docs') || params.isholdOrderDisable;
                    tempObj.disabledText = !params.Rights.hasOwnProperty('orders.docs') ? translate("order_Document_Permission_note") : (params.isholdOrderDisable ? translate("Label_Shipping_Label_On_Hold") : '');
               }
            }
            if (item.RdlName === "BOL") {
                tempObj.name = translate("Label_Generate_BOL");
                tempObj.disabled = ((params.SelectedOrders < 1) || !params.SameFacility || !params.SameCustomer || !params.Rights.hasOwnProperty('orders.docs') || params.isholdOrderDisable);
                tempObj.disabledText = !params.Rights.hasOwnProperty('orders.docs') ? translate("order_Document_Permission_note") : (!params.isholdOrderDisable ? translate("note_bill_of_lading") : translate("note_bill_of_lading_on_hold"));
                // if (params.SelectedOrders != 1) {
                //     tempObj.disabled = true;
                //     tempObj.disabledText = translate("note_bill_of_lading_multipleOrder");
                // }
                // else if(!params.SameFacility || !params.SameCustomer) {
                //     tempObj.disabled = true;
                //     tempObj.disabledText = translate("note_bill_of_lading");
                // }

            } else if (item.RdlName === "MasterBOL") {
                tempObj.name = translate("Label_Generate_MasterBOL");
                if (callFrom == "findOrder") {
                    tempObj.disabled = ((params.SelectedOrders <= 1) || !params.SameFacility || !params.SameCustomer || !params.FullyAllocated || !params.Rights.hasOwnProperty('orders.docs') || params.isholdOrderDisable);
                    tempObj.disabledText = params.SelectedOrders <= 1 ? translate("note_master_bill_of_lading") : translate("Label_Tooltip_OverAllocatedOrders_EditMasterBOL") + params.SelectedOrderIds;
                    tempObj.disabledText = !params.Rights.hasOwnProperty('orders.docs') ? translate("order_Document_Permission_note") :  (!params.isholdOrderDisable ? tempObj.disabledText : translate("Label_MasterBOL_On_Hold"));
                } else {
                    tempObj.disabled = (params.SelectedOrders < 1 || !params.Rights.hasOwnProperty('orders.docs'));
                }
            }
            if (item.RdlName !== "SmallParcel") {
                // && item.RdlName !== "BOL"
                if (item.hasOwnProperty('Reports') && item.RdlName !== "ShippingLabel") {
                    item.Reports.forEach((report, i) => {
                        tempObj.onClickFunc = () => null;
                        tempObj.value.push({
                            "name": report.Name,
                            "value": [],
                            "disabled": (tempObj.disabled == true || !params.Rights.hasOwnProperty('orders.docs')) ? true : false,
                            "disabledText": translate("order_Document_Permission_note"),
                            'isContextMenu': true,
                            'isButtonMenu': true,
                            "wmsSelector": params.Selector + fnName + (i + 1),
                            "onClickFunc": menuClickEvent,
                            'wmsid': fnName,
                            'runReport': report.TemplatedRunner,
                            'rdlName': item.RdlName,
                        });
                    });
                }

                updatedPrintMenu.PrintData.push(tempObj);

                // Add new option for edit bill of lading
                if (item.RdlName == "BOL") {

                    let appnedEditBolOpt = {
                        "name": translate('Label_Edit_Bill_of_Lading'),
                        "value": [],
                        "disabled": (params.SelectedOrders != 1 || !params.Rights.hasOwnProperty('orders.docs') || params.isholdOrderDisable),
                        "disabledText": !params.Rights.hasOwnProperty('orders.docs') ? translate("order_Document_Permission_note") : (params.isholdOrderDisable ? translate("note_edit_bill_of_lading_on_hold") : translate("note_edit_bill_of_lading")),
                        'isContextMenu': true,
                        'isButtonMenu': true,
                        "wmsSelector": params.Selector + item.RdlName,
                        "onClickFunc": menuClickEvent,
                        'wmsid': 'EditBol'
                    }
                    updatedPrintMenu.PrintData.push(appnedEditBolOpt);

                }
            }
        });

        updatedPrintMenu.PrintData.unshift({
            "name": translate('Label_Attach_Files'),
            "value": [],
            "disabled": (params.SelectedOrders != 1),
            "disabledText": translate("note_attach_files"),
            'isContextMenu': params.Rights.hasOwnProperty('orders.attachdocs') && params.Rights.hasOwnProperty('Shipping.AttachedDocsEnabled'),
            'isButtonMenu': params.Rights.hasOwnProperty('orders.attachdocs') && params.Rights.hasOwnProperty('Shipping.AttachedDocsEnabled'),
            "wmsSelector": params.Selector + "AttachFiles",
            "onClickFunc": menuClickEvent,
            'wmsid': "attachFiles"
        });
        updatedPrintMenu.PrintData.splice(1, 0, {
            "name": translate('Label_Pick_Ticket'),
            "value": [],
            "disabled": ((params.SelectedOrders < 1) || !params.EnablePickOption || !params.Rights.hasOwnProperty('orders.docs') || params.isholdOrderDisable),
            "disabledText": !params.Rights.hasOwnProperty('orders.docs') ? translate("order_Document_Permission_note") : (!params.isholdOrderDisable ? translate("Tooltip_FullyAllocated_TplSettingPrintOverAllocOrders") : translate("note_Master_Pick_Ticket_hold")),
            'isContextMenu': true,
            'isButtonMenu': true,
            "wmsSelector": params.Selector + "PickTicket",
            "onClickFunc": menuClickEvent,
            'wmsid': "pickTicket"
        });
        if (callFrom == "findOrder") {
            updatedPrintMenu.PrintData.splice(1, 0, {
                "name": translate('Label_Master_Pick_Ticket'),
                "value": [],
                "disabled": ((params.SelectedOrders <= 1) || (params.SelectedOrders > 10000) || !params.SameFacility || !params.SameCustomer || !params.SameBatchId || !params.Rights.hasOwnProperty('orders.docs') || params.isholdOrderDisable),
                "disabledText": !params.Rights.hasOwnProperty('orders.docs') ? translate("order_Document_Permission_note") : (params.SelectedOrders > 10000 ? translate("note_Master_Pick_Ticket_Limit") : (!params.isholdOrderDisable ? translate("note_Master_Pick_Ticket") : translate("note_Pick_Ticket_hold"))),
                'isContextMenu': true,
                'isButtonMenu': true,
                "wmsSelector": params.Selector + "MasterPickTicket",
                "onClickFunc": menuClickEvent,
                'wmsid': "masterPickTicket"
            });
            updatedPrintMenu.PrintData.splice(6, 0, {
                "name": translate('Label_Edit_Master_BOL'),
                "value": [],
                "disabled": ((params.SelectedOrders <= 1) || !params.SameFacility || !params.SameCustomer || !params.FullyAllocated || !params.Rights.hasOwnProperty('orders.docs') || params.isholdOrderDisable),
                "disabledText": !params.Rights.hasOwnProperty('orders.docs') ?
                    translate("order_Document_Permission_note") :
                    (
                        params.SelectedOrders <= 1 ? translate("note_Edit_Master_BOL") : (params.isholdOrderDisable ? translate("Label_Edit_MasterBOL_On_Hold") : translate("Label_Tooltip_OverAllocatedOrders_EditMasterBOL") + params.SelectedOrderIds)
                    ),
                'isContextMenu': true,
                'isButtonMenu': true,
                "wmsSelector": params.Selector + "EditMasterBOL",
                "onClickFunc": menuClickEvent,
                'wmsid': "editMasterBol"
            });
        }
        updatedPrintMenu.PrintData.splice(1, 0, {
            "name": translate('Label_Attach_Files_To_Batch'),
            "value": [],
            "disabled": !params.Rights.hasOwnProperty('admin.attachfiles'),
            'isContextMenu': params.Rights.hasOwnProperty('orders.attachdocs') && params.Rights.hasOwnProperty('Shipping.AttachedDocsEnabled'),
            'isButtonMenu': params.Rights.hasOwnProperty('orders.attachdocs') && params.Rights.hasOwnProperty('Shipping.AttachedDocsEnabled'),
            "wmsSelector": params.Selector + "AttachFilesToBatch",
            "onClickFunc": menuClickEvent,
            'wmsid': "attachFilesToBatch"
        });
        updatedPrintMenu.PrintData.push({
            "name": "Packing Slips",
            "value": [],
            "disabled": (params.SelectedOrders < 1 || !params.Rights.hasOwnProperty('orders.docs') || params.isholdOrderDisable
                || (params.usePapiPackingSlips && params.disablePapiPackingSlips)
                || (params.usePapiPackingSlips && !params.SameCustomer)
                || (params.usePapiPackingSlips && !params.SameFacility)),
            "disabledText": !params.Rights.hasOwnProperty('orders.docs') ? translate("order_Document_Permission_note")
                : (params.isholdOrderDisable ? translate("Label_Packing_Slips_On_Hold")
                : (params.usePapiPackingSlips && params.disablePapiPackingSlips) ? translate("Label_Packing_Slips_Must_Be_Packed")
                : (params.usePapiPackingSlips && !params.SameCustomer) ? translate("Label_Different_Customer")
                : (params.usePapiPackingSlips && !params.SameFacility) ? translate("Label_Different_Warehouse") : ''),
            'isContextMenu': true,
            'isButtonMenu': true,
            "wmsSelector": params.Selector + "RunReportPackingSlips",
            "onClickFunc": menuClickEvent,
            'wmsid': "runReportPackingSlips"
        });
        if (callFrom == "findOrder") {
            updatedPrintMenu.PrintData.push({
                "name": translate('Label_Shipping_Manifest'),
                "value": [],
                "disabled": ((params.SelectedOrders < 1) || !params.FullyAllocated || !params.Rights.hasOwnProperty('orders.docs') || params.isholdOrderDisable),
                "disabledText": !params.Rights.hasOwnProperty('orders.docs') ? translate("order_Document_Permission_note") : (params.isholdOrderDisable ? translate("Label_Shipping_Manifest_On_Hold") : translate("note_Shipping_Manifest") + params.SelectedOrderIds),
                'isContextMenu': true,
                'isButtonMenu': true,
                "wmsSelector": params.Selector + "ShippingManifest",
                "onClickFunc": menuClickEvent,
                'wmsid': "shippingManifest"
            });
        }
        updatedPrintMenu.PrintData.push({
            "name": "Send ASN",
            "value": [],
            "disabled": ((params.SelectedOrders < 1) || !params.SameFacility || !params.SameCustomer || !params.FullyAllocated || !params.TplSettings.Integrations.EdiEnabled || !params.Rights.hasOwnProperty('orders.docs') || params.isholdOrderDisable),
            "disabledText": !params.Rights.hasOwnProperty('orders.docs') ? translate("order_Document_Permission_note") : (params.isholdOrderDisable ? translate("Label_Send_Asn_On_Hold") : translate("note_Send_Asn")),
            'isContextMenu': true,
            'isButtonMenu': params.Rights.hasOwnProperty('orders.manage.sendasn'),
            "wmsSelector": params.Selector + "SendASN",
            "onClickFunc": menuClickEvent,
            'wmsid': "sendASN"
        });
    }

    return updatedPrintMenu;
}

export const getManageMenu = (params, menuClickEvent) => {
    var translate = window.translate;

    var manageMenuItems = [];

    manageMenuItems.push({
        "name": translate('Label_Hold_Orders'),
        "value": [],
        "disabled": params.SelectedOrders < 1 || !params.Rights.hasOwnProperty('orders.manage.hold'),
        "disabledText": params.SelectedOrders < 1 ? translate('Label_Please_Select_Orders') : translate('Label_No_Permission_Hold_Orders'),
        'isContextMenu': true,
        'isButtonMenu': true,
        "wmsSelector": params.Selector + "HoldOrders",
        "onClickFunc": menuClickEvent,
        'wmsid': "holdOrders"
    });

    manageMenuItems.push({
        "name": translate('Label_Release_Hold_Orders'),
        "value": [],
        "disabled": params.SelectedOrders < 1 || !params.Rights.hasOwnProperty('orders.manage.hold'),
        "disabledText": params.SelectedOrders < 1 ? translate('Label_Please_Select_Orders') : translate('Label_No_Permission_Release_Hold_Orders'),
        'isContextMenu': true,
        'isButtonMenu': true,
        "wmsSelector": params.Selector + "ReleaseHoldOrders",
        "onClickFunc": menuClickEvent,
        'wmsid': "releaseHoldOrders"
    });

    return manageMenuItems;
}